import React, { useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { editButtonSx, deleteButtonSx } from "../../shared/buttonStyles";
import SearchBar from "../../shared/SearchBar";

interface SimpleTableProps {
  handleUpdateClick: (row: { id: number; name: string }) => void;
  handleDelete: (id: number) => void;
  tableData: { id: number; name: string }[];
  head: string[];
  searchPlaceholder?: string;
}

export const SimpleTable: React.FC<SimpleTableProps> = ({
  handleUpdateClick,
  handleDelete,
  tableData,
  head,
  searchPlaceholder = "Search...",
}) => {
  const [search, setSearch] = useState("");

  const filteredData = tableData.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
    <SearchBar value={search} onChange={setSearch} placeholder={searchPlaceholder} />
    <TableContainer sx={{ flex: 1, overflow: "auto" }}>
      <Table aria-label="simple table" stickyHeader>
        <TableHead>
          <TableRow>
            {head.map((row, index: number) => (
              <TableCell key={index} sx={{ backgroundColor: "#FAFAFA", fontWeight: 600 }}>{row}</TableCell>
            ))}
            <TableCell align="center" sx={{ backgroundColor: "#FAFAFA", fontWeight: 600 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredData.length === 0 && (
            <TableRow>
              <TableCell colSpan={head.length + 1} align="center" sx={{ py: 4, color: "#878787" }}>
                No data found
              </TableCell>
            </TableRow>
          )}
          {filteredData.map((row, index: number) => (
            <TableRow
              key={index}
              hover
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                <Button variant="contained" onClick={() => handleUpdateClick(row)} sx={editButtonSx}>
                  Edit
                </Button>
                <Button variant="contained" onClick={() => handleDelete(row.id)} sx={deleteButtonSx}>
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
};
